import Component from "@tunnel-components/@sharded/modal/segmentation/component";
import * as React from "react";
import { SystemSettingsActionCreator } from "@tunnel-store/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @name  onChange
 * @name  onClickOnglet
 * @name  render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 550 millisecondes
  public debounceChange = Lodash.debounce((value: any) => {
    if (!Lodash.isEqual(value, "eudes")) {
      {
        /**  Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ sectionId: Number(value) }));
    } else {
      {
        /**  Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ sectionId: "eudes" }));
    }
  }, 550);

  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }      state
     * @property { number }      state.sectionId
     * ...
     */
    this.state = { sectionId: "" };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChange = this.onChange.bind(this);
  }
  /**
   * Changement des etats des inputs
   * @method onChange
   * @param { any }  event
   * @infos "https://cyclope.ai"
   */
  public onChange = (value: any): void => {
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChange(value);
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    // Stopper l'action une fois le component détruit
    this.debounceChange.cancel();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    this.props.SystemSettingsActionCreator();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }

    if (nextProps.isOpen !== this.props.isOpen) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (nextProps.isOpen === false) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ sectionId: "vide" }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component {...this.props} {...this.state} onChange={this.onChange} />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  return {
    error: state.SystemSettings.error,
    // loading: !!state.SystemSettings.// ,
    sections: state.SystemSettings.data,
  };
}

export default connect(mapStateToProps, { SystemSettingsActionCreator })(
  Container
);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/segmentation/container.tsx